import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import PrivacyPage from "@/pages/privacy/page";
import EditorialPage from "@/pages/editorial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/usfans-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/guides/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/usfans-spreadsheet/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "/editorial-policy",
    element: <EditorialPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;